export default __webpack_public_path__ + "static/media/2.ICONO-SOPORTE.abe885d6.png";